// extracted by mini-css-extract-plugin
module.exports = {"container":"Qr_container__2Co2h layouts_container__1HB9_","container__scan":"Qr_container__scan__3giVT","hidden":"Qr_hidden__1s3nC"};